import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import availabilityMgmt from './availabiltyMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import emailCampaigns from './emailCampaigns.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import claudia from './claudia.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import emailErrorCodes from './emailErrorCodes.json';
import emoji from './emoji.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import lockedFeature from './lockedFeature.json';
import voiceTeaser from './voiceTeaser.json';
import login from './login.json';
import macros from './macros.json';
import onboardingGuide from './onboardingGuide.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import teamsSettings from './teamsSettings.json';
import eddie from './eddie.json';
import whatsappTemplates from './whatsappTemplates.json';
import whatsappErrorCodes from './whatsappErrorCodes.json';
import sla from './sla.json';
import ssoWizard from './ssoWizard.json';
import voiceSoftphone from './voiceSoftphone.json';

import pageTitles from './pageTitles.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...availabilityMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...emailCampaigns,
  ...cannedMgmt,
  ...chatlist,
  ...claudia,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...emailErrorCodes,
  ...emoji,
  ...generalSettings,
  ...helpCenter,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...lockedFeature,
  ...voiceTeaser,
  ...login,
  ...macros,
  ...onboardingGuide,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...teamsSettings,
  ...eddie,
  ...whatsappTemplates,
  ...whatsappErrorCodes,
  ...sla,
  ...ssoWizard,
  ...voiceSoftphone,
  ...pageTitles,
};
